/*
 * mills-auth.js — ONE place that answers "what is the storefront token, and where is the API".
 *
 * The personal area used to work only for shoppers logged into Shopify: the token was minted
 * server-side into a <meta> tag, and every dashboard script read that tag. SMS login has no
 * Shopify session and no meta tag — the token comes back from /storefront/auth/otp/verify and
 * lives in localStorage. Without a single resolver, the scripts that read the meta tag ONLY
 * (dog-dashboard-api.js, -card-update-modal.js, -diagnostic.js) would let an SMS-logged-in
 * customer READ their dashboard and 401 on every WRITE — the worst kind of half-working.
 *
 * Precedence, most explicit first:
 *   1. ?mills_token= / ?mills_preview= in the URL   (a link just handed us one; preview = read-only)
 *   2. localStorage                                 (an SMS login stored one)
 *   3. <meta name="mills-storefront-token">         (Shopify-logged-in shopper, the old path)
 *
 * Loaded before every other dashboard script (layout/theme.liquid), so window.MillsAuth is
 * always defined by the time they run.
 */
(function (w, d) {
  var STORAGE_KEY = "mills.storefront.token";
  var DEFAULT_BASE = "https://mills.lets.co.il/storefront";
  var RENEWAL_HEADER = "X-Mills-Token";

  function readMeta(name) {
    var el = d.querySelector('meta[name="' + name + '"]');
    return el ? (el.getAttribute("content") || "").trim() : "";
  }

  function readUrl(param) {
    try {
      var m = (w.location.search || "").match(new RegExp("[?&]" + param + "=([^&]+)"));
      return m ? decodeURIComponent(m[1]) : "";
    } catch (_) {
      return "";
    }
  }

  function readStored() {
    try {
      return (w.localStorage.getItem(STORAGE_KEY) || "").trim();
    } catch (_) {
      return "";
    }
  }

  var MillsAuth = {
    STORAGE_KEY: STORAGE_KEY,

    /** A preview token is read-only (admin "view as customer"); writes must be refused. */
    isPreview: function () {
      return readUrl("mills_preview") !== "";
    },

    /** The best token available, or "" when the visitor is not authenticated at all. */
    token: function () {
      return readUrl("mills_preview") || readUrl("mills_token") || readStored() || readMeta("mills-storefront-token");
    },

    /** The /storefront API base — the meta tag on Shopify pages, the default elsewhere. */
    base: function () {
      return (readMeta("mills-storefront-api-base") || DEFAULT_BASE).replace(/\/$/, "");
    },

    /** Persist a token from SMS login so every later page and every write can use it. */
    setToken: function (token) {
      try {
        w.localStorage.setItem(STORAGE_KEY, (token || "").trim());
      } catch (_) {}
    },

    clear: function () {
      try {
        w.localStorage.removeItem(STORAGE_KEY);
      } catch (_) {}
    },

    /*
     * The server slides the login forward: once our stored token is a day old it answers
     * with a fresh one in X-Mills-Token, and storing it is what keeps a returning customer
     * signed in instead of being asked for an SMS code again. Only ever applied to a token
     * WE stored — a Shopify-logged-in shopper gets a new one minted into the page on every
     * load, and a read-only admin preview must never be upgraded into a lasting login.
     */
    absorbRenewal: function (response) {
      try {
        if (readUrl("mills_preview") || readUrl("mills_token")) return;

        var fresh = response && response.headers ? response.headers.get(RENEWAL_HEADER) : "";
        if (fresh && readStored()) MillsAuth.setToken(fresh);
      } catch (_) {}
    },

    /** Attach the bearer header when we have a token. Returns the headers object. */
    authorize: function (headers) {
      headers = headers || {};
      var t = MillsAuth.token();
      if (t) headers["Authorization"] = "Bearer " + t;
      return headers;
    },
  };

  w.MillsAuth = MillsAuth;
})(window, document);
